import { Loader } from "../../lib/loader";

export class OnlineAppLoader extends Loader {

    constructor(url, onlineApp, callback) {
        super(url, {}, callback);
        this.onlineApp = onlineApp;
    }

}



